import { Config, SettingsConfig } from "./configType";

export const nimbleSettings: SettingsConfig = {
  runConfiguration: process.env.REACT_APP_ENVIRONMENT,
  apiManagement: process.env.REACT_APP_NIM_APIM,
  ocpApimSubscriptionKey: process.env.REACT_APP_NIM_APIM_KEY,
  googleApiKey: process.env.REACT_APP_NIM_GOOGLE_API_KEY,
  leadMarketAffiliateCode: process.env.REACT_APP_NIM_LEAD_MARKET_AFFILIATE_CODE,
  leadMarketMode: process.env.REACT_APP_NIM_LEAD_MARKET_MODE,
  bankStatementIframeUrl: process.env.REACT_APP_NIM_BANK_STATEMENTS_IFRAME,
  shouldUseAsyncQueue: process.env.REACT_APP_NIM_SHOULD_USE_ASYNC_QUEUE,
  portalUrl: process.env.REACT_APP_NIM_PORTAL_URL,
  privacyPolicyPageFSA: process.env.REACT_APP_FSA_PRIVACY_POLICY,
  contentManagementUrl: process.env.REACT_APP_NIM_CDS_URL,
  contentToken: process.env.REACT_APP_NIM_CDS_TOKEN,
  trustPilotDataId: process.env.REACT_APP_NIM_TRUST_PILOT_DATA_ID,
  trustPilotBusinessUnit: process.env.REACT_APP_NIM_TRUST_PILOT_BUSINESS_UNIT,
  trustPilotURL: process.env.REACT_APP_NIM_TRUST_PILOT_URL,
  gtmId: process.env.REACT_APP_NIM_GTM_ID,
  gtmAuth: process.env.REACT_APP_NIM_GTM_AUTH,
  gtmPreview: process.env.REACT_APP_NIM_GTM_PREVIEW,
  useChatbot: process.env.REACT_APP_NIM_USE_CHATBOT,
  phone: process.env.REACT_APP_NIM_PHONE,
  email: process.env.REACT_APP_NIM_EMAIL,
  applyEmail: process.env.REACT_APP_NIM_APPLY_EMAIL,
  abn: process.env.REACT_APP_NIM_ACN,
  acl: process.env.REACT_APP_NIM_ACL,
  faq: process.env.REACT_APP_NIM_FAQ,
  companyName: process.env.REACT_APP_NIM_COMPANY_NAME,
  termsAndConditions: process.env.REACT_APP_NIM_TERMS_AND_CONDITIONS,
  privacy: process.env.REACT_APP_NIM_PRIVACY_POLICY,
  cdsApp: process.env.REACT_APP_NIM_CDS_APP,
  privacyConsentAndElectronicAuthorisation: process.env.REACT_APP_NIM_PRIVACY_CONSENT_AND_ELECTRONIC_AUTHORISATION,
  creditGuide: process.env.REACT_APP_NIM_CREDIT_GUIDE,
  salesforceBeaconScript: process.env.REACT_APP_NIM_SALESFORCE_BEACON_SCRIPT
};

export const nimbleConfig: Config = {
  partnerLogo: 'nimble-partnership-logo.svg',
  sharedPrivacyConsent: 'SHARING INFORMATION WITHIN OUR GROUP OF COMPANIES: To my personal, sensitive and credit information being shared with Nimble\'s related bodies corporate, including Fintech Services (Aust) Pty Ltd for analysis purposes.',
  sharedReportingConsent: 'To, and acknowledge that, my application may be notified to a credit reporting body, and I understand that even if I do not enter into a credit contract with Nimble Australia Pty Ltd, this may affect the decision of another lender to provide me with credit and the terms on which credit is offered.',
  declinePageContent: 'Unfortunately, we aren’t able to offer you a personal loan today. We understand this isn’t the news you were hoping for. However, if your situation changes, we’d welcome you to apply again!',
};

export const nimbleFavicon = '/favicon-nimble.png';